import gql from 'graphql-tag';

export default gql`
  query getCreditCards($paymentAccountIds: [UUID!]!) {
    payments {
      paymentMethods(paymentAccountIds: $paymentAccountIds)
    }
  }
`;
